import { useEffect } from "react";

import { TimeFrameType } from "src/organization/pages/project/environment/metrics/resources/types";

import PollerGroup from "./PollerGroup";
import usePoller from "./usePoller";

export type GroupPollerType<P = unknown, D = any> = {
  pollerId: string;
  requestFn: (timeFrame?: TimeFrameType | null) => Promise<D>;
  pollgroup: PollerGroup;
  pollImmediate?: boolean;
} & P;

const useGroupPoller = <D = any, P = unknown>({
  pollerId,
  requestFn,
  pollgroup,
  pollImmediate = true
}: GroupPollerType<P, D>) => {
  const result = usePoller<D>({ requestFn });

  useEffect(() => {
    pollgroup.registerOnce(pollerId, result.poller, pollImmediate);
  }, [pollgroup, result.poller, pollerId, pollImmediate]);

  useEffect(() => {
    return () => pollgroup.unregister(pollerId);
  }, [pollgroup, pollerId, result.poller]);

  return result;
};

export default useGroupPoller;
